import { c as _c } from "react/compiler-runtime";
import { FC } from "react";
interface ResultRowProps {
  label: string;
  value: string | number | undefined;
}
const ResultRow: FC<ResultRowProps> = t0 => {
  const $ = _c(7);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="w-[200px] text-neutral-675 text-opacity-60">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = value || "-";
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="min-w-[100px]">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <div className="text-app-body-1 flex w-full items-center">{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default ResultRow;